
export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50" style={{
      backgroundImage: 'url(https://public.readdy.ai/ai/img_res/23d0d0fc598d78b33efeb30c9eb671b1.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }}>
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900/80 to-purple-900/70"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 text-center">
        <div className="mb-8">
          <span className="inline-block px-4 py-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full text-white text-sm font-medium whitespace-nowrap">Secure Your Digital Life</span>
        </div>
        
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          Browse Safely with<br />
          <span className="bg-gradient-to-r from-blue-300 to-purple-300 bg-clip-text text-transparent">IMPRIME VPN</span>
        </h1>
        
        <p className="text-xl md:text-2xl text-white/90 mb-12 max-w-3xl mx-auto leading-relaxed">
          Experience ultimate online privacy and security with our advanced VPN technology. Protect your data, hide your location, and browse the internet without restrictions.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button onClick={scrollToContact} className="bg-white text-blue-600 px-8 py-4 rounded-full font-semibold text-lg hover:shadow-2xl transition-all whitespace-nowrap cursor-pointer flex items-center space-x-2">
            <span>Download Now</span>
            <i className="ri-download-line"></i>
          </button>
          <button onClick={scrollToContact} className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer">Learn More</button>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6">
            <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-white text-2xl"></i>
            </div>
            <h3 className="text-white font-bold text-lg mb-2 whitespace-nowrap">Military-Grade Encryption</h3>
            <p className="text-white/80 text-sm">Your data is protected with AES-256 encryption</p>
          </div>
          
          <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6">
            <div className="w-12 h-12 bg-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-speed-up-line text-white text-2xl"></i>
            </div>
            <h3 className="text-white font-bold text-lg mb-2 whitespace-nowrap">Lightning Fast Speed</h3>
            <p className="text-white/80 text-sm">Optimized servers for seamless browsing</p>
          </div>
          
          <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6">
            <div className="w-12 h-12 bg-pink-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-global-line text-white text-2xl"></i>
            </div>
            <h3 className="text-white font-bold text-lg mb-2 whitespace-nowrap">Global Server Network</h3>
            <p className="text-white/80 text-sm">Access content from anywhere in the world</p>
          </div>
        </div>
      </div>
    </section>
  );
}
